import { Text } from "@adfenix/alexandria";
import { TemplateUiModel } from "routes/back-office/program-builder/details/campaign/meta/template/TemplateUiModel";
import styled from "styled-components";
import { channelIcons } from "utils/channelIcons";
import { channelToCamelCase } from "utils/types";

interface Props {
  template: TemplateUiModel;
}

const StyledIcon = styled.i`
  margin-left: 18px;
`;

export const TemplateName = ({ template }: Props) => {
  return (
    <Text size="l">
      {template.name}
      {template.channels.map((channel, index) => (
        <StyledIcon
          key={index}
          className={`uil uil-${channelIcons[channelToCamelCase(channel)]}`}
        />
      ))}
    </Text>
  );
};
